import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

import { getRouter, type AppRouter } from "./router";
import "./styles.css";

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
}

const router = getRouter();
const root = document.getElementById("root");

if (!root) throw new Error("Application root element was not found.");

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
